<mat-slide-toggle (change)="change($event)">Dark</mat-slide-toggle>
